import { render, staticRenderFns } from "./TopicCard.vue?vue&type=template&id=13ac15a4&scoped=true"
import script from "./TopicCard.vue?vue&type=script&lang=ts"
export * from "./TopicCard.vue?vue&type=script&lang=ts"
import style0 from "./TopicCard.vue?vue&type=style&index=0&id=13ac15a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ac15a4",
  null
  
)

export default component.exports